/* eslint-disable @next/next/no-img-element */
import { FC } from 'react';

import { useTheme } from 'styled-components';
import { useSidebar } from '~/layouts/private/providers/sidebar';
import { usePrivateLayout } from '~/layouts/private/providers/privateLayout';

import { useAuth } from '~/common/providers/auth';
import { Typography } from '~/common/components/Typography';
import { Button } from '~/common/components/Button';

import {
  CollapseArrowWrapper,
  SidebarHeaderContainer,
  UserInfo,
} from './styles';
import { Avatar } from '../../Avatar';

import { ISidebarProps } from '..';

export const SidebarHeader: FC<ISidebarProps> = ({ closeMobileSidebar }) => {
  const {
    user: { name },
  } = useAuth();
  const { isMobile } = usePrivateLayout();
  const { collapse, collapsed } = useSidebar();
  const theme = useTheme();

  return (
    <SidebarHeaderContainer>
      <Avatar />

      {!collapsed && (
        <>
          <UserInfo>
            <Typography.Label size="small" color="neutral.0">
              {name}
            </Typography.Label>
          </UserInfo>
        </>
      )}

      <CollapseArrowWrapper>
        <Button
          withoutHoverEffect
          justifyContent="center"
          icon={collapsed ? 'menu-fold-4-fill' : 'more-2-fill'}
          backgroundColor={theme.transparent}
          borderColor={theme.neutral[400]}
          height={isMobile ? '40' : '24'}
          width={isMobile ? '40px' : '24px'}
          iconSize={isMobile ? 30 : 20}
          textOrIconColor={theme.neutral[400]}
          tooltip={collapsed ? 'Expandir menu' : 'Colapsar menu'}
          onClick={closeMobileSidebar || collapse}
        />
      </CollapseArrowWrapper>
    </SidebarHeaderContainer>
  );
};
